<template>
  <div class="content">
    <base-snack-bar
      v-model="snackbar.show"
      :message="snackbar.message"
    />
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <crud-cadastro
        :loading="loading"
      >
        <v-card
          class="px-6 pt-4"
          outlined
          style="margin-top: 14px; border-radius: 16px"
        >
          <v-card-title
            class="pa-0"
            style="text-shadow: grey 0.1em 0.1em 0.2em;"
          >
            Dados do Serviço
          </v-card-title>
          <v-row>
            <v-col
              cols="3"
              md="2"
            >
              <v-text-field
                v-model="codigo"
                :rules="[rules.required]"
                label="Código*"
                required
                validate-on-blur
                outlined
                rounded
                dense
              />
            </v-col>
            <v-col
              cols="9"
              md="4"
            >
              <v-text-field
                v-model="nome"
                :rules="[rules.required]"
                label="Nome*"
                required
                validate-on-blur
                outlined
                rounded
                dense
              />
            </v-col>

            <v-col
              cols="5"
              md="4"
            >
              <v-autocomplete
                v-model="categoria_id"
                :items="categorias"
                item-text="nome"
                item-value="id"
                :rules="[rules.required]"
                class="d-flex justify-space-between"
                label="Categoria*"
                outlined
                rounded
                dense
              >
                <template
                  slot="item"
                  slot-scope="data"
                >
                  <v-container
                    class="rounded-lg mx-n2"
                    fluid
                  >
                    <v-row
                      dense
                      justify="space-between"
                    >
                      <div>{{ data.item.nome }}</div>
                    </v-row>
                  </v-container>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col
              cols="3"
              md="2"
            >
              <v-autocomplete
                v-model="unidade_id"
                :items="unidades"
                item-text="nome"
                item-value="id"
                :rules="[rules.required]"
                class="d-flex justify-space-between"
                label="Unidade*"
                outlined
                rounded
                dense
              >
                <template
                  slot="item"
                  slot-scope="data"
                >
                  <v-container
                    class="rounded-lg mx-n2"
                    fluid
                  >
                    <v-row
                      dense
                      justify="space-between"
                    >
                      <div>{{ data.item.nome }}</div>
                    </v-row>
                  </v-container>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
            >
              <v-textarea
                v-model="descricao"
                :rules="[rules.required]"
                label="Descrição*"
                validate-on-blur
                outlined
                rounded
              />
            </v-col>
          </v-row>
        </v-card>
        <v-row
          class="pa-3"
          justify="center"
          justify-sm="end"
        >
          <v-btn
            class="text-none text-white mr-3"
            color="error"
            rounded
            @click="$router.push({ path: `/${$user.get().role}/cdc/servicos` })"
          >
            <v-icon
              dark
              left
            >
              mdi-minus-circle
            </v-icon>
            Cancelar
          </v-btn>
          <v-btn
            class="text-none text-white"
            color="success"
            :disabled="desabilitaBotao"
            rounded
            @click="submitForm"
          >
            <v-icon
              dark
              left
            >
              mdi-checkbox-marked-circle
            </v-icon>
            {{ isEditing ? 'Salvar' : 'Cadastrar' }}
          </v-btn>
        </v-row>
      </crud-cadastro>
    </v-form>
  </div>
</template>
<script>
  import { mapFields } from 'vuex-map-fields'
  import rules from '../../utils/formRules'
  import ServicoFormStore, { BOOTSTRAP_PROFILE, SUBMIT } from '@/store/modules/forms/servico'
  import { mapState, mapActions } from 'vuex'
  import { v4 } from 'uuid'
  export default {
    data () {
      return {
        money: {
          locale: 'pt-BR',
          precision: 3,
        },
        valid: false,
        numImagens: 1,
        rules,
        snackbar: { message: '', show: false },
      }
    },
    computed: {
      ...mapState('form/servico', [
        'unidades',
        'categorias',
        'loading',
        'isEditing',
      ],
      ),
      ...mapFields('form', [
        'data.nome',
        'data.codigo',
        'data.unidade_id',
        'data.categoria_id',
        'data.descricao',
      ],
      ),
      desabilitaBotao () {
        return this.loading || !this.valid
      },
    },
    created () {
      if (!this.$store.state.form.servico) { this.$store.registerModule(['form', 'servico'], ServicoFormStore) }
      const id = this.$route.query.id
      this.BOOTSTRAP_PROFILE({ id })
    },
    methods: {
      ...mapActions('form/servico', [BOOTSTRAP_PROFILE, SUBMIT]),
      addEspacoImagem () {
        if (this.numImagens < 10) {
          this.imagensVec.push({ id: v4(), img: null })
        }
      },
      deleteImg (index) {
        this.$delete(this.imagensVec, index)
      },
      submitForm () {
        if (!this.$refs.form.validate()) {
          this.snackbar = {
            show: true,
            message: 'Existem campos Obrigatórios não prenchidos. Por favor, preencha-os!',
          }
          return null
        }
        this.SUBMIT({ user: this.$user, router: this.$router })
      },
    },
  }
</script>
